<form [formGroup]="maneuversForm" *ngIf="!disableManeuvers()">
	<div class="grid mt-3">
		<div class="col-12 py-0">
			<p-tag class="flex align-items-center justify-content-center gap-2" icon="pi cm-manuvers"
				value="{{ 'MANEUVERS' | translate }}: {{ device.Engagements.toString() }}"
				severity="warning">
			</p-tag>
		</div>
		<div class="col-12">
			<div class="flex justify-content-center align-items-center">
				<p-checkbox formControlName="maneuvers" [binary]="true" value="true"></p-checkbox>
				<span class="pi cm-manuvers text-2xl mx-2"></span>
				{{ 'MANEUVERS' | translate }} {{ 'AND' | translate }} {{ 'DATE_NOTIFY_MAINTENANCE' | translate }}
			</div>
		</div>
	</div>
	<!-- ROW-->
	<div class="grid flex align-items-center">
		<div [ngClass]="col12Responsive()">
			<div class="flex justify-content-between flex-wrap"
				[ngClass]="newShowErrors(this.fManeuvers.maneuversNum,'borderRow')">
				<div class="flex align-items-center justify-content-center gap-2"
					[ngClass]="newShowErrors(this.fManeuvers.maneuversNum,'label')">{{ 'MANEUVERS' | translate }}
					<p-button pTooltip="{{'MANEUVERS_MESSAGE' | translate }}" tooltipPosition="bottom" icon="pi cm-help"
						size="large" [rounded]="false" [text]="true" severity="primary">
					</p-button>
				</div>
				<div class="flex align-items-end justify-content-center"
					[ngClass]="newShowErrors(this.fManeuvers.maneuversNum,'borderInput')">
					<p-inputNumber formControlName="maneuversNum" inputId="minmax-buttons" step="1" [useGrouping]="false"
						[maxFractionDigits]="0" [showButtons]="true" [min]="0" incrementButtonClass="p-0"
						decrementButtonClass="p-0 border-noround" inputStyleClass="border-noround-right"
						[ngClass]="dynamicInputTextDesktopTabletWidth()" [styleClass]="dynamicInputTextDesktopTabletWidth()">
						<!-- (onInput)="selectManeuversNum()" (onKeyDown)="selectManeuversNum()" -->
					</p-inputNumber>
				</div>
			</div>
			<small *ngIf="showErrorRequiredMessage(this.fManeuvers.maneuversNum)"
				class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{ 'REQUIRED' |
				translate }}</small>
		</div>
		<div [ngClass]="col12Responsive()">
			<div class="flex justify-content-between flex-wrap"
				[ngClass]="newShowErrors(this.fManeuvers.limitDate,'borderRow')">
				<div class="flex align-items-center justify-content-center gap-2"
					[ngClass]="newShowErrors(this.fManeuvers.limitDate,'label')">{{ 'DATE_NOTIFY_MAINTENANCE' | translate }}
					<p-button pTooltip="{{'NOTIFY_DATE_LIMIT_MESSAGE' | translate }}" tooltipPosition="bottom" icon="pi cm-help"
						size="large" [rounded]="false" [text]="true" severity="primary">
					</p-button>
				</div>
				<div class="flex align-items-end justify-content-center"
					[ngClass]="newShowErrors(this.fManeuvers.limitDate,'borderInput')">
					<p-calendar [showIcon]="true" inputId="icon" formControlName="limitDate" appendTo="body"
						placeholder="dd/mm/yyyy" [minDate]="today" [keepInvalid]="true" [defaultDate]="today" dateFormat="dd/mm/yy"
						inputStyleClass="border-noround-right" [ngClass]="dynamicInputTextDesktopTabletWidth()"
						[styleClass]="dynamicInputTextDesktopTabletWidth()">
						<!-- (onSelect)="selectDate()" -->
					</p-calendar>
				</div>
			</div>
			<small *ngIf="showErrorRequiredMessage(this.fManeuvers.limitDate)" class="flex align-items-center text-50 pt-1"
				[ngClass]="justifyMessagesNewValidator()">{{ 'REQUIRED' | translate }}. {{ 'INSERT_MIN_DATE_TODAY' | translate }}.</small>
		</div>
		<div class="col-12 flex justify-content-center">
			<p-button *ngIf="!disableManeuvers()"
				label="{{ 'SAVE' | translate }} {{ 'MANEUVERS' | translate }} {{ 'AND' | translate }} {{ 'DATE_NOTIFY_MAINTENANCE' | translate }}"
				icon="pi cm-check" styleClass="border-primary font-semibold"
				[rounded]="false" [text]="true" severity="primary" (click)="submit()">
			</p-button> <!-- [disabled]="hideSaveManeuvers()" -->
		</div>
	</div>
</form>